import React, { useState, useEffect } from "react";
import axios from "axios";
import { LuPencil, LuTrash2 } from "react-icons/lu";
import { API, colors } from "../shared/constants";
import { styles, inputStyle, labelStyle, fieldStyle } from "../shared/styles";
import { SimpleModal } from "../shared/SimpleModal";

export function SuppliersSettings() {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const loadAll = () => {
    axios.get(`${API}/suppliers/`)
      .then((res) => setSuppliers(res.data || []))
      .finally(() => setLoading(false));
  };
  useEffect(() => { loadAll(); }, []);

  const openAdd = () => {
    setEditing(null);
    setName("");
    setError("");
    setShowModal(true);
  };

  const openEdit = (s) => {
    setEditing(s);
    setName(s.name);
    setError("");
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!name.trim()) { setError("Supplier name is required."); return; }
    setSaving(true); setError("");
    try {
      if (editing) {
        await axios.patch(`${API}/suppliers/${editing.id}/`, { name: name.trim() });
      } else {
        await axios.post(`${API}/suppliers/`, { name: name.trim(), is_active: true });
      }
      setShowModal(false);
      loadAll();
    } catch {
      setError("Something went wrong. Please try again.");
    }
    setSaving(false);
  };

  const handleDelete = async (s) => {
    if (!window.confirm(`Delete supplier "${s.name}"?`)) return;
    await axios.delete(`${API}/suppliers/${s.id}/`);
    loadAll();
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={styles.topbar}>
        <div style={styles.pageTitle}>Suppliers</div>
        <button style={styles.addButton} onClick={openAdd}>+ Add Supplier</button>
      </div>

      <div style={styles.content}>
        {loading ? (
          <div style={styles.loading}>Loading…</div>
        ) : suppliers.length === 0 ? (
          <div style={{ padding: "48px 24px", textAlign: "center", color: colors.slate, fontSize: "14px" }}>
            No suppliers yet. Click "+ Add Supplier" to get started.
          </div>
        ) : (
          <div style={styles.card}>
            <div style={{
              display: "grid", gridTemplateColumns: "1fr 80px",
              padding: "8px 20px",
              backgroundColor: "#f8fafc",
              borderBottom: `1px solid ${colors.border}`,
              fontSize: "11px", fontWeight: 700, color: colors.slate,
              textTransform: "uppercase", letterSpacing: "0.4px",
            }}>
              <div>Supplier Name</div>
              <div></div>
            </div>
            {suppliers.map((s) => (
              <div key={s.id} style={{
                display: "grid", gridTemplateColumns: "1fr 80px",
                padding: "11px 20px", borderBottom: `1px solid ${colors.border}`,
                alignItems: "center", backgroundColor: colors.white,
              }}>
                <div style={{ fontSize: "14px", color: colors.text, fontWeight: 500 }}>{s.name}</div>
                <div style={{ display: "flex", gap: "4px", justifyContent: "flex-end" }}>
                  <button onClick={() => openEdit(s)} title="Edit" style={{
                    background: "none", border: "none", cursor: "pointer",
                    color: colors.slate, padding: "4px", borderRadius: "4px",
                    display: "flex", alignItems: "center",
                  }}><LuPencil size={15} /></button>
                  <button onClick={() => handleDelete(s)} title="Delete" style={{
                    background: "none", border: "none", cursor: "pointer",
                    color: "#dc2626", padding: "4px", borderRadius: "4px",
                    display: "flex", alignItems: "center",
                  }}><LuTrash2 size={15} /></button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showModal && (
        <SimpleModal
          title={editing ? `Edit: ${editing.name}` : "New Supplier"}
          onClose={() => setShowModal(false)}
          onSave={handleSave}
          saving={saving}
          error={error}
        >
          <div style={fieldStyle}>
            <label style={labelStyle}>Supplier Name *</label>
            <input
              style={inputStyle}
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSave()}
              autoFocus
            />
          </div>
        </SimpleModal>
      )}
    </div>
  );
}
